import { API, graphqlOperation } from "aws-amplify";
import { createPrice_info, deletePrice_info, updatePrice_info } from "../../graphql/mutations";
import { getPrice_info, listPrice_infos } from "../../graphql/queries";

export const CreatePrice = async (postParams) => {
    try {
      const result = await API.graphql(
        graphqlOperation(createPrice_info, postParams)
      );
      return result.data.createPrice_info;
    } catch (res) {
      const { errors } = res;
      console.error(errors);
    }
};

export const GetPrice = async () => {
    try {
      const result = await API.graphql(graphqlOperation(listPrice_infos));
      const data = result.data.listPrice_infos;
      return data;
    } catch (res) {
      const { errors } = res;
      console.error(errors);
    }
  };
  
  export const GetPriceByID = async (id) => {
    try {
      const result = await API.graphql(graphqlOperation(getPrice_info, {price_id: id}));
      const data = result.data.getPrice_info;
      return data;
    } catch (res) {
      const { errors } = res;
      console.error(errors);
    }
  };
  
  export const DeletePrice = async (params) => {
    try {
      const result = await API.graphql(graphqlOperation(deletePrice_info, params));
      return result.data.deletePrice_info;
    } catch (res) {
      const { errors } = res;
      console.error(errors);
    }
  };
  
  export const UpdatePrice = async (postParams) => {
    try {
      const result = await API.graphql(graphqlOperation(updatePrice_info, postParams));
      return result.data.updatePrice_info;
    } catch (res) {
      const { errors } = res;
      console.error(errors);
    }
  };